/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "return",

    getDefaultProps: function getDefaultProps() {
        return {
            "return": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "78.8",
            "height": "66.9"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 78.8 66.9", className: "return", width: this.props.width, height: this.props.height, style: this.props["return"] },
            _react2["default"].createElement("path", { fill: "#999", d: "M78.8 40.1c0-14.7-12-26.7-26.7-26.8H20.2V0L0 20.2l20.2 20.2V27h32c7.1.1 12.9 5.9 12.9 13 0 7.2-5.8 13-12.9 13H9.7v13.7h42.4c14.8.1 26.7-11.9 26.7-26.6z" })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/return.js